module.exports = __webpack_public_path__ + "img/大通_LOGO_320x150.d91eda68.png";